package com.essntl.features.dashboard.ui.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Divider
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.key
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import com.essntl.features.dashboard.ui.DashboardEvent
import com.essntl.features.dashboard.ui.DashboardNavigation
import com.essntl.features.dashboard.ui.DashboardState
import com.essntl.features.dashboard.ui.components.taskcard.TaskCard
import com.essntl.uikit.components.button.outline.EsMediumOutlineButton
import com.essntl.uikit.components.spinner.EsSpinner
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun DashboardTasks(
    state: DashboardState,
    onNavigation: (DashboardNavigation) -> Unit,
    onEvent: (DashboardEvent) -> Unit,
    selectedId: String?,
) {
    val isLoading = remember(state) { state.tasksLoading }
    val isFailure = remember(state) { state.tasksFailure }

    Column(
        modifier = Modifier
            .padding(top = 1.spacing)
            .clip(RoundedCornerShape(EsConstants.SectionBorderRadius))
            .background(MaterialTheme.esColorScheme.bgSecondary)
            .padding(
                vertical = EsConstants.SectionVerticalPadding,
                horizontal = EsConstants.SectionHorizontalPadding,
            )
            .fillMaxWidth(.4F)
            .fillMaxHeight(),
    ) {
        Text(
            text = "Tasks",
            color = MaterialTheme.esColorScheme.textPrimary,
            style = MaterialTheme.esTypography.h4SemiBold20,
            modifier = Modifier
                .fillMaxWidth()
                .padding(vertical = 1.spacing),
        )

        Spacer(modifier = Modifier.height(1.5.spacing))

        if (isLoading &&
            state.getAllTask.data.isEmpty()
        ) {
            EsSpinner(
                modifier = Modifier.align(Alignment.CenterHorizontally),
            )
        } else if (isFailure) {
            Text(
                text = "Something goes wrong!",
                color = MaterialTheme.esColorScheme.textSecondary,
                style = MaterialTheme.esTypography.p1Medium16,
            )
        } else if (state.getAllTask.data.isEmpty()) {
            Text(
                text = "Nothing was found!",
                color = MaterialTheme.esColorScheme.textSecondary,
                style = MaterialTheme.esTypography.p1Medium16,
            )
        } else
            Column(
                horizontalAlignment = Alignment.CenterHorizontally,
                modifier = Modifier.fillMaxWidth(),
            ) {
                state.getAllTask.data.forEach { task ->
                    key(task.id) {
                        TaskCard(
                            state = state,
                            task = task,
                            selectedId = selectedId,
                            onClick = {
                                onNavigation(DashboardNavigation.EditTask(task.id))
                            },
                        )

                        HorizontalDivider(
                            color = MaterialTheme.colorScheme.secondary.copy(alpha = 0.5f),
                        )
                    }
                }

                if (!state.getAllTask.isLastPage) {
                    Spacer(modifier = Modifier.height(2.spacing))

                    EsMediumOutlineButton(
                        onClick = {
                            onEvent(DashboardEvent.LoadTasks)
                        },
                        text = "Load more",
                        loading = isLoading,
                    )

                    Spacer(modifier = Modifier.height(2.spacing))
                }
            }
    }
}